__turbopack_context__.v({
  "container": "GoogleMap-module__ZHqk9q__container",
  "fadeInItems": "GoogleMap-module__ZHqk9q__fadeInItems",
  "info": "GoogleMap-module__ZHqk9q__info",
  "spacing--lg": "GoogleMap-module__ZHqk9q__spacing--lg",
  "spacing--md": "GoogleMap-module__ZHqk9q__spacing--md",
  "spacing--sm": "GoogleMap-module__ZHqk9q__spacing--sm",
  "spacing--xl": "GoogleMap-module__ZHqk9q__spacing--xl",
  "spacing--xs": "GoogleMap-module__ZHqk9q__spacing--xs",
  "spacing--xxl": "GoogleMap-module__ZHqk9q__spacing--xxl",
  "spacing--xxs": "GoogleMap-module__ZHqk9q__spacing--xxs",
  "spacing--xxxl": "GoogleMap-module__ZHqk9q__spacing--xxxl",
  "spacing--xxxs": "GoogleMap-module__ZHqk9q__spacing--xxxs",
});
